'use client'

import posthog from 'posthog-js'

/**
 * The only place in the app that calls `posthog.identify` / `posthog.reset`
 * directly, mirroring `lib/posthog-capture.ts` for events — a single seam for
 * PostHog identity control.
 */
export function identifyPostHogUser(userId: string, properties: Record<string, unknown>): void {
  posthog.identify(userId, properties)
  posthog.reloadFeatureFlags()
}

/** Drop the PostHog distinct_id so it can't leak across users on a shared device. */
export function resetPostHogIdentity(): void {
  posthog.reset()
}
